import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Modal from 'react-modal';

// images
import greyX from '../../../images/grey-x.svg';

// components
import Notifications from '../../Notifications';

// services
import AuthService from '../../../services/AuthService';
import TerritoryService from '../../../services/TerritoryService';

function EditTerritoryModal({ isOpen, toggleMenu, territory }) {
    const navigate = useNavigate();

    const [code, setCode] = useState('');
    const [description, setDescription] = useState('');
    const [salesPerson, setSalesPerson] = useState('');

    useEffect(() => {
        if (territory) {
            setCode(territory.code)
            setDescription(territory.description)
            setSalesPerson(territory.salesPerson)
        }
    }, [territory])

    const handleSaveClick = () => {
        let validated = true;

        if (code === "") {
            Notifications("error", "Code is required.")
            validated = false;
        }
        if (description === "") {
            Notifications("error", "Description is required.")
            validated = false;
        }
        if (salesPerson === "") {
            Notifications("error", "Sales Person is required.")
            validated = false;
        }

        if (validated) {
            const updatedTerritory = {
                id: territory.id,
                code: code,
                description: description,
                salesPerson: salesPerson
            }
            TerritoryService.updateTerritory(
                updatedTerritory
            ).then(response => {
                Notifications('success', 'Territory has been updated.')

                toggleMenu(updatedTerritory)
            }).catch(err => {
                if (err.statusCode === 401 && err.message === 'Token is expired, please update your token.') {
                    AuthService.logout()
                    navigate('/login')
                }
                Notifications("error", err['message'])
            });
        }
    };

    return (
        <Modal
            isOpen={isOpen}
            onRequestClose={() => toggleMenu()}
            ariaHideApp={false}
            closeTimeoutMS={200}
            className='modal-territory'
        >   
            <div className='modal-body'>
                <div className='modal-header'>
                    <h2><b>Edit Territory</b></h2>
                    <button className='close' onClick={() => toggleMenu()}>
                        <img src={greyX} alt="Close"/>
                    </button>
                </div>
                <div className="details">
                    <div>
                        <span>
                            Territory Code
                        </span>
                        <input 
                            type='text'
                            placeholder='Enter Territory Code'
                            value={code}
                            onChange={(e) => setCode(e.target.value)}
                            className='input input__form'
                        />
                    </div>
                    <div>
                        <span>
                            Description
                        </span>
                        <input 
                            type='text'
                            placeholder='Enter Description'
                            value={description}
                            onChange={(e) => setDescription(e.target.value)}
                            className='input input__form'
                        />
                    </div>
                    <div>
                        <span>
                            Sales Person
                        </span>
                        <input 
                            type='text'
                            placeholder='Enter Sales Person'
                            value={salesPerson}
                            onChange={(e) => setSalesPerson(e.target.value)}
                            className='input input__form'
                        />
                    </div>
                </div>
            </div>
            <div className="modal-footer">
                <button
                    className='link__form-add'
                    onClick={handleSaveClick}
                >
                    Save
                </button>
            </div>
        </Modal>
    );
};

export default EditTerritoryModal;